import React, { useCallback, useState } from "react";
import cx from "classnames";
import GenericModal from "shared/components/GenericModal";
import Button from "shared/Button";
import SubscriptionPreviewBlock from "./SubscriptionPreviewBlock";
import { useDispatch, useSelector } from "react-redux";
import { upgrade30PodSku } from "shared/utility";
import { updateFrequency, updateSubscriptionProducts } from "./actions";

const UpgradeTo60PodModal = ({ onClose, subscription, show }) => {
  const dispatch = useDispatch();
  const skuMap = useSelector(s => s.config.planConfigs.GB?.skuMap);

  const [isUpgrading, setIsUpgrading] = useState(false);
  const [errorText, setErrorText] = useState(null);

  const onUpgradeSubscription = useCallback(() => {
    setIsUpgrading(true);

    // Update products first...
    dispatch(
      updateSubscriptionProducts(subscription.id, {
        products: subscription.products.map(({ id, variant, quantity }) => {
          const upgradedSku = upgrade30PodSku(variant.sku);
          const newVariantSummary = skuMap[upgradedSku];

          return {
            id: id,
            product_id: newVariantSummary.item.product_id,
            variant_id: newVariantSummary.item.variant_id,
            quantity
          };
        })
      })
    )
      .then(
        () =>
          dispatch(
            updateFrequency(subscription.id, {
              interval: subscription.interval * 2
            })
          ),
        err => {
          setIsUpgrading(false);
          setErrorText(err);
        }
      )
      .then(() => {
        // We've updated both the frequency and the products in the sub.
        // Now we just bail out and hopefully all should be well.
        onClose();
      })
      .finally(() => setIsUpgrading(false));
  }, [dispatch, onClose, skuMap, subscription]);

  if (!subscription) {
    return null;
  }

  return (
    <GenericModal
      className={cx("modal-dialog-centered")}
      onClose={onClose}
      show={show}
    >
      <div className="modal-header">
        <h4 className="body-20 fw-bold">
          Upgrade to a 60 pod box subscription to save money and the planet.
        </h4>
        <button
          aria-label="Close"
          className="btn-close"
          onClick={onClose}
          type="button"
        />
      </div>
      <div className="modal-body">
        <p className="body-15">
          If you decide to opt-in, after your next order you'll start receiving
          your deliveries at half the frequency. This will be at a reduced price
          of £25, versus what would have been the previous price of £27 (£13.50
          per refill pack).
        </p>
        <p className="body-15 mt-3">
          Your deliveries will still be sent in letterbox friendly packaging -
          so you don't have to worry about missing a delivery.
        </p>
        <hr className="border-top mt-5 mb-3 opacity-75" />
        <SubscriptionPreviewBlock subscription={subscription} />
        <hr className="border-top mb-3 mt-4 opacity-75" />
        <Button
          className="w-100"
          isLoading={isUpgrading}
          onClick={onUpgradeSubscription}
          size="md"
        >
          Upgrade my subscription now
        </Button>
        <button
          className="w-100 mt-2 border-0 bg-white body-15 fw-medium py-2"
          onClick={onClose}
          type="button"
        >
          <u>Stay on my current subscription</u>
        </button>

        {errorText && (
          <p className="body-15 text-center text-danger mt-3">{errorText}</p>
        )}
      </div>
    </GenericModal>
  );
};

export default UpgradeTo60PodModal;
